/* eslint max-len: 0 */

import generateAbsoluteLinks from './generateAbsoluteLinks'


/*

 if you need add route to autotests in CI add:

 autotest: {
  auth: Boolean,                                // if true (check route only with auth)
                                                // if false (check route only with no auth)
                                                // if undefined (check with auth and no auth)
  screenshot: Boolean,                          // match screenshots tests
  currentPath: String,                          // path for :slug, :id, etc
  XSSparams: String[]                           // if we use query params in url on route,
                                                // we can check the XSS vulnerability
  redirect: Boolean                             // block redirect error in route (if you need)
 }

 you can also use array of autotests

 */

const links = {
  home: { path: '' },
  homeMen: { path: 'men' },

  // Auth

  register: { path: 'register', analytics: { page: 'register' }, autotest: { auth: false, screenshot: true } },
  login: { path: 'register/log-in', analytics: { page: 'login' }, autotest: { auth: false } }, // TODO change to /login
  remindPassword: { path: 'register/remind-password', analytics: { page: 'remind password' }, autotest: { auth: false } },
  resetPassword: { path: 'register/password-reset', analytics: { page: 'rest password' } },
  logout: { path: 'logoff' },

  // SEO

  perfumes: { path: 'perfumes', analytics: { page: 'seo perfumes' } },
  colognes: { path: 'colognes', analytics: { page: 'seo colognes' } },

  // Payment

  checkout: { path: 'subscription/payment', analytics: { page: 'checkout', pageType: 'payment' }, autotest: { auth: false, redirect: true } },
  subscribe: { path: 'subscribe', analytics: { page: 'subscribe', pageType: 'payment' }, autotest: { auth: false } },
  subscribeNew: { path: 'subscribe-prototype', analytics: { page: 'subscribe', pageType: 'payment' } },
  giftRedeem: { path: 'gift/redeem', analytics: { page: 'gift redeem', pageType: 'payment' }, autotest: { disabled: true } },
  couponPayment: { path: 'subscription/payment/coupon', analytics: { page: 'coupon subscription payment', pageType: 'payment' } },
  giftCardPayment: { path: 'giftcard/payment', analytics: { page: 'gift card payment', pageType: 'payment' } },
  giftSubscriptionPayment: { path: 'gift/payment', analytics: { page: 'gift subscription payment', pageType: 'payment' } },

  // New payment flow

  queueRedeem: { path: 'queue/redeem', analytics: { page: 'payment', pageType: 'payment' } },
  tossInRedeem: { path: 'toss-in/redeem', analytics: { page: 'payment', pageType: 'payment' } },

  // Unsubscribe

  cancelSubscription: { path: 'subscription/cancel', analytics: { page: 'cancel subscription', pageType: 'cancel subscription' } },

  // Resubscribe

  resub: { path: 'resub', analytics: { page: 'resubscribe card', pageType: 'resubscribe' } },
  resubscribe: { path: 'resubscribe', analytics: { page: 'resubscribe new', pageType: 'resubscribe' } },
  resubscribe3: { path: 'resubscribe-3', analytics: { page: 'resubscribe 3 months', pageType: 'resubscribe' } },
  resubscribe5: { path: 'resubscribe-5', analytics: { page: 'resubscribe 5 months', pageType: 'resubscribe' } },
  resubscribe50: { path: 'resubscribe-50', analytics: { page: 'resubscribe 50% discount', pageType: 'resubscribe' } },
  resubscribeFree: { path: 'resubscribe-free', analytics: { page: 'resubscribe 1 month free', pageType: 'resubscribe' } },
  resubscribe5mo12: { path: 'resubscribe-5mo12', analytics: { page: 'resubscribe 5 months by $12', pageType: 'resubscribe' } },

  // Unpause

  unpause: { path: 'unpause', analytics: { page: 'unpause', pageType: 'unpause' } },
  unpause50: { path: 'unpause-50', analytics: { page: 'unpause 50', pageType: 'unpause' } },

  // Card update

  cardUpdate: { path: 'card-update', analytics: { page: 'card update', pageType: 'card update' } },
  cardUpdate50: { path: 'card-update-50', analytics: { page: 'card update 50% discount', pageType: 'card update' } },
  caseCardUpdate: { path: 'case-card-update', analytics: { page: 'case card update', pageType: 'card update' } },

  // Gift

  gift: { path: 'gift', analytics: { page: 'gift' }, autotest: { disabled: true } },
  gifts: { path: 'gifts', analytics: { page: 'gifts', pageType: 'gifts' }, autotest: { disabled: true } },
  giftFb: { path: 'gift-fb', analytics: { page: 'gifts facebook' } },
  giftCard: { path: 'giftcard', analytics: { page: 'gift cards' }, autotest: {} },
  giftSet: { path: 'giftset', analytics: { page: 'women gift sets', pageType: 'gift sets' }, autotest: {} }, // TODO why not giftset`S` ?
  giftSetsMen: { path: 'giftset-men', analytics: { page: 'men gift sets', pageType: 'gift sets' }, autotest: {} },
  newGiftSet: { path: 'giftset/:name', analytics: { page: 'gift set' }, autotest: { currentPath: 'giftset/hollywood-diva' } },
  skincareSets: { path: 'skincare-set', analytics: { page: 'skincare sets' }, autotest: {} },
  skincareSet: { path: 'skincareset/:name', analytics: { page: 'skincare set' }, autotest: { currentPath: 'skincareset/ultimate-skin-collection' } },

  // Products

  /*
   TODO: Do something with products links structure. Maybe like that:
   skincare: { body, lip }
   makeup: { eye, lip, face, cheek, tools }
   */

  newProducts: { path: 'new', analytics: { page: 'new products', pageType: 'products' }, autotest: {} },
  scentbirdProducts: { path: 'scentbird-products', analytics: { page: 'scentbird products' } },
  scentbirdProductsNew: { path: 'brand/scentbird', analytics: { page: 'scentbird products' } },
  howHandCreamsWork: { path: 'hand-creams/how-it-works', analytics: { page: 'hand creams how it works' }, autotest: {} },
  skincare: { path: 'skincare', analytics: { page: 'skincare products' } },
  wellness: { path: 'wellness', analytics: { page: 'wellness products' } },

  // !isNewSkincareEnabled
  goldCollection: { path: 'gold-collection', analytics: { page: 'skincare gold collection products' } }, // TODO deprecated
  goldCollectionMen: { path: 'collections-men/gold-collection', analytics: { page: 'skincare gold collection products' } },
  goldCollectionWomen: { path: 'collections-women/gold-collection', analytics: { page: 'skincare gold collection products' } },
  handCreams: { path: 'hand-creams', analytics: { page: 'hand cream products' } }, // TODO deprecated
  bodyLip: { path: 'body-lip', analytics: { page: 'body lip products' } }, // TODO deprecated

  // TODO deprecated
  skincareLip: { path: 'skincare-lip', analytics: { page: 'skincare lip products' } },
  skincareEye: { path: 'skincare-eye', analytics: { page: 'skincare eye products' } },
  skincareCleansers: { path: 'skincare-cleansers', analytics: { page: 'skincare cleansers products' } },
  skincareMasks: { path: 'skincare-masks', analytics: { page: 'skincare masks products' } },
  skincareMoisturizers: { path: 'skincare-moisturizers', analytics: { page: 'skincare moisturizers products' } },
  skincareTreatments: { path: 'skincare-treatments', analytics: { page: 'skincare treatments products' } },
  skincareMens: { path: 'skincare-mens', analytics: { page: 'skincare mens products' } },
  skincareWellness: { path: 'skincare-wellness', analytics: { page: 'skincare wellness products' } },

  personalCare: { path: 'personal-care', analytics: { page: 'personal care products' } },
  personalCareBodyMoisturizers: { path: 'personal-care/body-moisturizers', analytics: { page: 'personal care body moisturizers products' } },
  personalCareHandCreams: { path: 'personal-care/hand-creams', analytics: { page: 'personal care hand creams products' } },
  personalCareShower: { path: 'personal-care/shower', analytics: { page: 'personal care shower products' } },
  personalCareShowerBodyWash: { path: 'personal-care/shower/body-wash', analytics: { page: 'personal care body wash products' } },
  personalCareShowerBodyScrub: { path: 'personal-care/shower/body-scrubs', analytics: { page: 'personal care body scrub products' } },

  makeup: { path: 'makeup', analytics: { page: 'makeup products' }, autotest: {} },
  makeupBrand: { path: 'makeup/brand/:brandName', analytics: { page: 'makeup brand' } },

  // isNewMakeupUrlsEnabled
  makeupPalettes: { path: 'makeup/palettes', analytics: { page: 'makeup palettes products' } },
  makeupEye: { path: 'makeup/eye', analytics: { page: 'makeup eye products' } },
  makeupEyeMascara: { path: 'makeup/eye/mascara', analytics: { page: 'makeup eye mascara products' } },
  makeupEyeEyebrow: { path: 'makeup/eye/eyebrow', analytics: { page: 'makeup eye eyebrow products' } },
  makeupEyeTreatment: { path: 'makeup/eye/eye-treatment', analytics: { page: 'makeup eye treatment products' } },
  makeupEyeEyeliner: { path: 'makeup/eye/eyeliner', analytics: { page: 'makeup eye eyeliner products' } },
  makeupEyePrimer: { path: 'makeup/eye/eye-primer', analytics: { page: 'makeup eye primer products' } },
  makeupEyeEyeshadow: { path: 'makeup/eye/eyeshadow', analytics: { page: 'makeup eye eyeshadow products' } },
  makeupLip: { path: 'makeup/lip', analytics: { page: 'makeup lip products' } },
  makeupLipLiner: { path: 'makeup/lip/lip-liner', analytics: { page: 'makeup lip liner products' } },
  makeupLipLipstick: { path: 'makeup/lip/lipstick', analytics: { page: 'makeup lip lipstick products' } },
  makeupLipLipgloss: { path: 'makeup/lip/lip-gloss', analytics: { page: 'makeup lip lipgloss products' } },
  makeupFace: { path: 'makeup/face', analytics: { page: 'makeup face products' } },
  makeupFacePrimer: { path: 'makeup/face/face-primer', analytics: { page: 'makeup face primer products' } },
  makeupConcealer: { path: 'makeup/face/concealer', analytics: { page: 'makeup concealer products' } },
  makeupFaceFoundation: { path: 'makeup/face/foundation', analytics: { page: 'makeup face foundation products' } },
  makeupCheek: { path: 'makeup/cheek', analytics: { page: 'makeup cheek products' } },
  makeupCheekBlush: { path: 'makeup/cheek/blush', analytics: { page: 'makeup cheek blush products' } },
  makeupCheekHighlight: { path: 'makeup/cheek/highlighter', analytics: { page: 'makeup cheek highlight products' } },
  makeupTools: { path: 'makeup/tools', analytics: { page: 'makeup tools products' } },
  makeupToolsBrushes: { path: 'makeup/tools/brushes', analytics: { page: 'makeup tools brushes products' } },

  candles: { path: 'candles', analytics: { page: 'candle products' } },
  bestsellersMen: { path: 'bestsellers-men', analytics: { page: 'men bestsellers', pageType: 'bestsellers' } },
  bestsellersWomen: { path: 'bestsellers-women', analytics: { page: 'women bestsellers', pageType: 'bestsellers' } },
  collectionMen: { path: 'collections-men/:name', analytics: { page: 'men collections', pageType: 'collections' } },
  collectionWomen: { path: 'collections-women/:name', analytics: { page: 'women collections', pageType: 'collections' } },
  skincareCollectionItemMenNew: { path: 'skincare-men/collections/:name', analytics: { page: 'men collections', pageType: 'collections' } },
  skincareCollectionItemWomenNew: { path: 'skincare/collections/:name', analytics: { page: 'women collections', pageType: 'collections' } },
  skincareCollectionWomen: { path: 'skincare-collections-women', analytics: { page: 'skincare collections women', pageType: 'collections' } },
  skincareCollectionMen: { path: 'skincare-collections-men', analytics: { page: 'skincare collections men', pageType: 'collections' } },
  skincareCollectionWomenNew: { path: 'skincare/collections', analytics: { page: 'skincare collections women', pageType: 'collections' } },
  skincareCollectionMenNew: { path: 'skincare-men/collections', analytics: { page: 'skincare collections men', pageType: 'collections' } },
  bambooCharcoalCollection: { path: 'collections-men/bamboo-charcoal', analytics: { page: 'bamboo charcoal collection products', pageType: 'collections' } },
  productTypeCollectionMen: { path: ':slug-collections-men', analytics: { page: 'men collections', pageType: 'collections' } },
  productTypeCollectionWomen: { path: ':slug-collections-women', analytics: { page: 'women collections', pageType: 'collections' } },
  productTypeCollectionMenNew: { path: ':slug-men/collections', analytics: { page: 'men collections', pageType: 'collections' } },
  productTypeCollectionWomenNew: { path: ':slug/collections', analytics: { page: 'women collections', pageType: 'collections' } },
  collectionLanding: { path: 'collections/:slug', analytics: { page: 'collection landing', pageType: 'collections' } },
  flashSale: { path: 'flash-sale', analytics: { page: 'flash sale' } },
  fathersDayGiftSet: { path: 'bamboo-charcoal', analytics: { page: 'bamboo charcoal gift set' } },

  // Product

  productPageCommonProduct: { path: 'product/:slug', analytics: { page: 'product', pageType: 'product' }, autotest: { currentPath: 'product/505' } },
  productPagePerfumes: { path: 'perfumes/:slug', analytics: { page: 'perfume product', pageType: 'product' } },
  productPagePerfume: { path: 'perfume/:slug', analytics: { page: 'perfume product', pageType: 'product' }, autotest: { screenshot: true, currentPath: 'perfume/robert-graham-fortitude-1103' } },
  productPageHandCreams: { path: 'hand-creams/:slug', analytics: { page: 'hand cream product', pageType: 'product' } },
  productPageHandCream: { path: 'hand-cream/:slug', analytics: { page: 'hand cream product', pageType: 'product' } },
  productPageBody: { path: 'body/:slug', analytics: { page: 'body product', pageType: 'product' } },
  productPageBodyLip: { path: 'body-lip/:slug', analytics: { page: 'body lip product', pageType: 'product' } },
  productPageShowerGels: { path: 'shower-gels/:slug', analytics: { page: 'shower gel product', pageType: 'product' } },
  productPageShowerGel: { path: 'shower-gel/:slug', analytics: { page: 'shower gel product', pageType: 'product' } },
  productPageCandles: { path: 'candles/:slug', analytics: { page: 'candle product', pageType: 'product' } },
  productPageCandle: { path: 'candle/:slug', analytics: { page: 'candle product', pageType: 'product' } },
  productMakeupOld: { path: 'makeup(.*)/:slug', analytics: { page: 'makeup product', pageType: 'product' } },
  productMakeup: { path: 'makeup/(.*)/:slug', analytics: { page: 'makeup product', pageType: 'product' } },
  oldProductSkincare: { path: 'skincare-(.*)/:slug', analytics: { page: 'skincare product', pageType: 'product' } },
  productSkincare: { path: 'skincare(.*)/:slug', analytics: { page: 'skincare product', pageType: 'product' } },
  productExtra: { path: 'extra/:slug', analytics: { page: 'extra product', pageType: 'product' } },
  productExtras: { path: 'extras/:slug', analytics: { page: 'extra product', pageType: 'product' } },
  productLanding: { path: 'perfume-landing/:slug', analytics: { page: 'perfume landing product', pageType: 'product' } },
  productPersonalCare: { path: 'personal-care/(.*)/:slug', analytics: { page: 'personal care product', pageType: 'product' } },

  // Common

  faq: { path: 'faq', analytics: { page: 'faq' } },
  pick: { path: 'pick', analytics: { page: 'pick' }, autotest: { auth: false } }, // TODO add 'screenshot' to autotest when there will be static products feed
  case: { path: 'case', analytics: { page: 'case sub' } },
  plan: { path: 'plan', analytics: { page: 'plan' } },
  team: { path: 'team', analytics: { page: 'team' }, autotest: {} },
  blog: { path: 'blog', analytics: { page: 'blog' } },
  queue: { path: 'queue', analytics: { page: 'queue' } },
  terms: { path: 'terms', analytics: { page: 'terms and conditions' } },
  press: { path: 'press', analytics: { page: 'press' } },
  choose: { path: 'choose', analytics: { page: 'choose' } },
  tossIn: { path: 'toss-in', analytics: { page: 'toss in' } },
  invite: { path: 'invite', analytics: { page: 'invite', pageType: 'invite' } },
  fInvite: { path: 'f/invite', analytics: { page: 'women invite', pageType: 'invite' } }, // TODO looks weird - https://scentbird.slack.com/archives/C3CB4J1MW/p1544046136165500
  mInvite: { path: 'm/invite', analytics: { page: 'men invite', pageType: 'invite' } }, // TODO looks weird - https://scentbird.slack.com/archives/C3CB4J1MW/p1544046136165500
  contact: { path: 'contact', analytics: { page: 'contact' } },
  blogger: { path: 'blogger', analytics: { page: 'blogger' } },
  privacy: { path: 'privacy', analytics: { page: 'privacy policy' } },
  request: { path: 'request', analytics: { page: 'request perfume' } },
  upgrade: { path: 'upgrade', analytics: { page: 'upgrade' } },
  coupons: { path: 'coupons', analytics: { page: 'coupons' }, autotest: {} },
  welcome: { path: 'welcome', analytics: { page: 'welcome' }, autotest: { auth: false } },
  careers: { path: 'careers', analytics: { page: 'careers' }, autotest: {} },
  buyQueue: { path: 'buy-queue', analytics: { page: 'buy queue' } },
  thankYou: { path: 'thankyou', analytics: { page: 'thankyou' } },
  men25Off: { path: 'men/25-off', analytics: { page: '25-off' } },
  tracking: { path: 'tracking', analytics: { page: 'tracking' }, autotest: { auth: true, screenshot: true } },
  popupShop: { path: 'popupshop', analytics: { page: 'popup shop' } },
  casePrize: { path: 'case-prize', analytics: { page: 'case prize' } },
  downgrade: { path: 'downgrade', analytics: { page: 'downgrade' } },
  howItWorks: { path: 'how-it-works', analytics: { page: 'how it works' }, autotest: {} },
  unsubscribe: { path: 'unsubscribe', analytics: { page: 'unsubscribe' }, autotest: { auth: true } },
  searchResult: { path: 'search-result', analytics: { page: 'search result' } },
  payPalUpdate: { path: 'paypal-update', analytics: { page: 'update to paypal' } },
  giftCardTerms: { path: 'giftcards-terms', analytics: { page: 'gift cards terms' } },
  claimGiftCard: { path: 'claim', analytics: { page: 'claim gift card' }, autotest: {} },
  makeupLanding: { path: 'makeup-landing', analytics: { page: 'makeup landing' }, autotest: { auth: false } },
  skincareIntro: { path: 'skincare-intro', analytics: { page: 'skincare intro' }, autotest: { auth: false } },
  improveSurvey: { path: 'improve-survey', analytics: { page: 'customer survey' }, autotest: { auth: true } },
  improveRecommendations: { path: 'improve-recommendations', analytics: { page: 'improve recommendations' } /* , autotest: { auth: true } */ },
  fragranceFinder: { path: 'fragrance-finder', analytics: { page: 'fragrance finder' } },
  popularInStates: { path: 'popular-in-states', analytics: { page: 'popular in states' }, autotest: {} },
  scentbirdReviews: { path: 'scentbird-reviews', analytics: { page: 'scentbird reviews' }, autotest: {} },
  affiliateProgram: { path: 'affiliate-program', analytics: { page: 'affiliate program' } },
  upgradeProduct: { path: 'upgrade-product', analytics: { page: 'upgrade product' } },
  upgradePrepaid: { path: 'prepaid-plans', analytics: { page: 'prepaid plans' } },
  upgradePlan: { path: 'upgrade-plan', analytics: { page: 'upgrade simple' } },
  upgradeWithDiscount: { path: 'upgrade-:plan', analytics: { page: 'upgrade with discount' } },
  facebookEmailRegistration:  { path: 'facebook-email', analytics: { page: 'register facebook email' } },
  freeScentbirdPefumeSocial:  { path: 'free-scentbird-perfume-social', analytics: { page: 'free scentbird perfume' } },
  successfulEmailVerification: { path: 'opted-in', analytics: { page: 'successful email verification' } },
  caseMonthlyDesign: { path: 'case-monthly', analytics: { page: 'case monthly design' } },
  caseSubscription: { path: 'case-subscription', analytics: { page: 'case subscription' } },

  // Mix
  mix: { path: 'mix-intro', analytics: { page: 'mix' } },
  mixWelcome: { path: 'mix-welcome', analytics: { page: 'mix welcome' } },

  // Horoscope

  horoscope: { path: 'horoscope', analytics: { page: 'horoscopes' }, autotest: {} },
  zodiacSign: { path: 'horoscope/:name', analytics: { page: 'horoscope' }, autotest: { currentPath: 'horoscope/leo' } },

  // Quiz

  quiz: { path: 'onboarding', analytics: { page: 'women onboarding', pageType: 'onboarding' }, autotest: {} },
  quizMen: { path: 'onboarding-men', analytics: { page: 'men onboarding', pageType: 'onboarding' } },
  quizProduct: { path: 'onboarding-product', analytics: { page: 'onboarding product' } },

  // Profile

  profile: {
    root: { path: 'profile', analytics: { page: 'profile', pageType: 'profile' } },
    upgradeSubscription: { path: 'upgrade', analytics: { page: 'profile upgrade subscription' } },
    billingAndShipping: { path: 'billing-and-shipping', analytics: { page: 'profile billing and shipping' }, autotest: { auth: true } },
    password: { path: 'password', analytics: { page: 'profile change password' }, autotest: { auth: true } },
    ordersStatus: { path: 'orders-status', analytics: { page: 'profile orders status' } },
    productsInQueue: { path: 'products-in-queue', analytics: { page: 'profile queue' }, autotest: { auth: true, screenshot: true } },
    ratedProducts: { path: 'rated-products', analytics: { page: 'profile rated products' } },
    reviews: { path: 'reviews', analytics: { page: 'profile reviews' } },
    sentGifts: { path: 'sent-gifts', analytics: { page: 'profile sent gifts' } },
    myOrders: { path: 'orders', analytics: { page: 'profile orders' } },
    order: { path: 'order/:id', analytics: { page: 'profile order' } },
    personal: { path: 'personal', analytics: { page: 'profile personal info' }, autotest: { auth: true } },
  },

  // Other user profile

  userProfile: {
    root: { path: 'p/:userId', analytics: { page: 'other user profile', pageType: 'other user profile' } },
    receivedProducts: { path: 'received-products', analytics: { page: 'other user profile received products' } },
    productsInQueue: { path: 'products-in-queue', analytics: { page: 'other user profile queue' } },
    ratedProducts: { path: 'rated-products', analytics: { page: 'other user profile rated products' } },
    reviews: { path: 'reviews', analytics: { page: 'other user profile reviews' } },
  },

  subscription: {
    root: { path: 'subscription' },

    // Smartsearch

    smartSearch: { path: 'smartsearch', analytics: { page: 'smartsearch all', pageType: 'smartsearch' } },
    bestsellers: { path: 'bestsellers', analytics: { page: 'smartsearch bestsellers', pageType: 'smartsearch' } },
    bestsellersAll: { path: 'bestsellers-all', analytics: { page: 'smartsearch all bestsellers', pageType: 'smartsearch' } }, // link from emails // TODO looks weird - https://scentbird.slack.com/archives/C3CB4J1MW/p1544003052109700
    newArrivals: { path: 'newarrivals', analytics: { page: 'smartsearch newarrivals', pageType: 'smartsearch' } },
    featured: { path: 'featured', analytics: { page: 'smartsearch featured', pageType: 'smartsearch' } },
    perfumes: { path: 'perfumes', analytics: { page: 'smartsearch perfumes', pageType: 'smartsearch' }, autotest: { auth: true } },
    colognes: { path: 'colognes', analytics: { page: 'smartsearch colognes', pageType: 'smartsearch' }, autotest: { auth: true, screenshot: true } },

    // Main

    mainMen: { path: 'main-men', analytics: { page: 'men main', pageType: 'main' }, autotest: { auth: true } },
    mainWomen: { path: 'main-women', analytics: { page: 'women main', pageType: 'main' }, autotest: { auth: true } },
    mainMenEmpty: { path: 'main-men-empty', analytics: { page: 'men empty main', pageType: 'main' } }, // TODO looks weird - https://scentbird.slack.com/archives/C3CB4J1MW/p1544003882111600
    mainWomenEmpty: { path: 'main-women-empty', analytics: { page: 'women emty main', pageType: 'main' } }, // TODO looks weird - https://scentbird.slack.com/archives/C3CB4J1MW/p1544003882111600

    // Other subscription

    extras: { path: 'extras', analytics: { page: 'extra products' }, autotest: { auth: true } },
    collectionsMen: { path: 'collections-men', analytics: { page: 'men collections', pageType: 'collections' }, autotest: { auth: true } },
    collectionsWomen: { path: 'collections-women', analytics: { page: 'women collections', pageType: 'collections' }, autotest: { auth: true } },
    recommendations: { path: 'recommendations', analytics: { page: 'recommendations' } },
    cologneOfTheMonth: { path: 'cologne-of-the-month/:year/:month', analytics: { page: 'men pom', pageType: 'pom' }, autotest: { currentPath: 'cologne-of-the-month/2018/08' } },
    perfumeOfTheMonth: { path: 'perfume-of-the-month/:year/:month', analytics: { page: 'women pom', pageType: 'pom' }, autotest: { currentPath: 'perfume-of-the-month/2018/08' } },
    currCologneOfTheMonth: { path: 'cologne-of-the-month', analytics: { page: 'men pom', pageType: 'pom' } },
    currPerfumeOfTheMonth: { path: 'perfume-of-the-month', analytics: { page: 'women pom', pageType: 'pom' } },
  },

  // Brands page

  brand: { path: 'brand/:slug', analytics: { page: 'brand' }, autotest: { auth: false, currentPath: 'brand/gucci', redirect: true } },

  // Info

  info: {
    root: { path: 'info' },
    howTo: { path: 'howto', analytics: { page: 'how to' } },
    subscribeFor1445: { path: '1445', analytics: { page: '1445', pageType: 'women 1445' } },
    recommendations: { path: 'recommendations', analytics: { page: 'recommendations info' } },
    aboutScentbird: { path: 'about_scentbird', analytics: { page: 'about scentbird' } },
  },

  // Men info

  menInfo: {
    root: { path: 'men/info' },
    subscribeFor1445: { path: '1445', analytics: { page: '1445', pageType: 'men 1445' } },
  },

  // Affiliate

  affiliate: {
    root: { path: 'affiliate' },
    faq: { path: 'faq', analytics: { page: 'affiliate faq' } },
    contact: { path: 'contact', analytics: { page: 'affiliate contact' } },
    request: { path: 'request', analytics: { page: 'affiliate request' } },
    strategies: { path: 'strategies', analytics: { page: 'affiliate strategies' } },
    promoResources: { path: 'promo-resources', analytics: { page: 'affiliate promo resources' } },
    starterPackage: { path: 'starter-package', analytics: { page: 'affiliate starter package' } },
  },

  // Incubator
  incubator: {
    root: { path: 'incubator' },
    neonHeat: { path: 'neon-heat', analytics: { page: 'incubator neon heat' } },
    fragranceConcepts: { path: 'fragrance-concepts', analytics: { page: 'incubator fragrance concepts' } },
    queue: { path: 'queue' },
  },

  // Scentbird Special
  special: { path: 'special/:token', analytics: { page: 'special' } },

  // ScentBeat
  genres: { path: 'genres' },

  // Makeup on face sandbox
  makeupOnFace: { path: 'try-makeup' },

  // Membership
  membership: { path: 'membership', analytics: { page: 'membership' } },

  referralLanding: { path: 'referral/:channelCode/:personalCode', analytics: { page: 'referral landing' } },

  // Notes
  noteWomen: { path: 'notes/:slug/women', analytics: { page: 'note women' } },
  noteMen: { path: 'notes/:slug/men', analytics: { page: 'note men' } },

  // Collections for sale
  collectionsForSale: { path: 'collections-for-sale', analytics: { page: 'collections for sale' } },
  collectionForSale: { path: 'collections-for-sale/:slug', analytics: { page: 'collection for sale' } },

  // TasteMaker
  tasteMaker: { path: 'tastemaker', analytics: { page: 'tastemaker' } },

  // Mobile app web view
  siteApi: {
    root: { path: 'site-api' },
    teamPage: { path: 'team-page-html' },
  },
}

const absoluteLinks = generateAbsoluteLinks(links)

let fromBackend = {}

Object.defineProperty(absoluteLinks, 'fromBackend', {
  get: () => fromBackend,
  set: (links: { [name: string]: string }) => {
    fromBackend = { ...links }
  },
})


export default absoluteLinks

export {
  links,
}
